import ThemeButton from "components/Buttons/ThemeButton";
import styled, { css } from "styled-components";

export const Container = styled.div<{ scale: number; image: string }>`
	transform: scale(${(props) => props?.scale});
	font-size: 10px;
	width: 32.3em;
	border-radius: 24px;
	background-image: url(${(props) => props.image});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	padding: 2em;
	display: flex;
	justify-content: space-between;
	text-align: center;
	flex-direction: column;

	div {
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: 1em;

		> div:nth-of-type(1) {
			@media (orientation: landscape) or (min-width: 900px) {
				flex-direction: row;
				gap: 2em;
			}
		}
	}

	@media (orientation: landscape) or (min-width: 900px) {
		width: 92.4em;
		padding: 1.8em;
	}
`;

const commonTextStyles = css`
	paint-order: stroke fill;
	font-family: "Baloo";
	font-weight: 400;
	text-align: center;
	filter: drop-shadow(0 0.07em 0 #000);
	-webkit-text-stroke-color: #000;
	font-style: normal;
	margin: 0;
`;

export const Title = styled.h1`
	${commonTextStyles}
	color: #fbbd05;
	text-align: center;
	-webkit-text-stroke-width: 0.1433em;
	font-size: 4.3em;
	line-height: 0.9302em;
	margin-top: 1em;

	@media (orientation: landscape) or (min-width: 900px) {
		font-size: 5.2em;
		margin-top: 0.8269em;
	}
`;

export const Description = styled.p`
	${commonTextStyles}
	color: #fff;
	text-align: center;
	-webkit-text-stroke-width: 0.1121em;
	font-size: 2.3em;
	line-height: 1.173em;
	margin-bottom: 7.739em;

	@media (orientation: landscape) or (min-width: 900px) {
		font-size: 3.3em;
		margin-bottom: 1.909em;
	}
`;

export const WarningMessage = styled.p<{ color?: string }>`
	${commonTextStyles}
	color: ${(props) => props.color || "#FFF"};
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.45);
	font-family: "Inter";
	font-size: 1.6em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.125em;

	@media (orientation: landscape) or (min-width: 900px) {
		text-shadow: none;
	}
`;

export const Button = styled(ThemeButton)`
	width: 14.3809em;
	font-size: 2.1em;

	@media (orientation: landscape) or (min-width: 900px) {
		width: 18.9em;
		font-size: 1.45em;
	}
`;
